import React, { useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import User_Info from "../../common_components/user_info/User_Info";
import { useDispatch } from "react-redux";
import { AuthChangePin } from "../../../features/auth/Slice";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Change_Pin = () => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState("");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
    console.log("Form Data: ", data);
    // Here you can dispatch the change pin action
    const result = await dispatch(AuthChangePin(data));

    if (result.payload.success) {
      setSuccess("Pin changed successfully!");
      reset(); // Reset the form after successful submission
      setTimeout(() => {
        setSuccess("");
      }, 3000); // Clear success message after 3 seconds
    } else {
      await setError("old_pin", {
        type: "manual",
        message: result.payload.errors.old_pin?.msg,
      });
      await setError("pin", {
        type: "manual",
        message: result.payload.errors.pin?.msg,
      });
    }
  };

  const [showOldPin, setShowOldPin] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);

  return (
    <section className="Manage_My_Points Change_Pin">
      <div className="user_info_div">
        <div className="row me-0 ms-0">
          <div className="col-lg-3 col-sm-8 col-12 my-3">
            <User_Info />
          </div>
        </div>
      </div>

      <div className="note_info_div">
        <div className="row me-0 ms-0">
          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-1 order-1 mb-2"></div>

          <div className="col-xxl-8 col-lg-6 col-md-12 order-lg-2 order-3 mb-2">
            {success && (
              <div className="alert alert-success" role="alert">
                {success}
              </div>
            )}

            <div>
              <div className="manage_points_main_div mt-2">
                <div className="title_div">
                  <p className="title_text">:: Change Your Pin</p>
                </div>

                <div className="transfer_form_div">
                  <Form>
                    <div className="inputs_div">
                      <Form.Group className="common_form_group">
                        <Form.Label>Old Pin:</Form.Label>
                        <div className="password_eye_field">
                          <Form.Control
                            type={showOldPin ? "text" : "password"}
                            placeholder="Enter Old PIN"
                            inputMode="numeric"
                            maxLength={6}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            {...register("old_pin", {
                              required: "Old PIN is required",
                              minLength: {
                                value: 4,
                                message: "Old PIN must be at least 4 digits",
                              },
                              pattern: {
                                value: /^[0-9]+$/,
                                message: "Old PIN must contain only numbers",
                              },
                            })}
                          />

                          <span
                            className="password_eye_icon"
                            onClick={() => setShowOldPin((prev) => !prev)}
                          >
                            {showOldPin ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </Form.Group>

                      {errors.old_pin && (
                        <sub className="text-danger">
                          {errors.old_pin.message}
                        </sub>
                      )}

                      <Form.Group className="common_form_group">
                        <Form.Label>New Pin:</Form.Label>
                        <div className="password_eye_field">
                          <Form.Control
                            type={showPin ? "text" : "password"}
                            placeholder="Enter PIN"
                            inputMode="numeric"
                            maxLength={6}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            {...register("pin", {
                              required: "PIN is required",
                              minLength: {
                                value: 4,
                                message: "PIN must be at least 4 digits",
                              },
                              pattern: {
                                value: /^[0-9]+$/,
                                message: "PIN must contain only numbers",
                              },
                            })}
                          />

                          <span
                            className="password_eye_icon"
                            onClick={() => setShowPin((prev) => !prev)}
                          >
                            {showPin ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </Form.Group>

                      {errors.pin && (
                        <sub className="text-danger">{errors.pin.message}</sub>
                      )}

                      <Form.Group className="common_form_group">
                        <Form.Label>Cfm New Pin:</Form.Label>
                        <div className="password_eye_field">
                          <Form.Control
                            type={showConfirmPin ? "text" : "password"}
                            placeholder="Enter Confirm PIN"
                            inputMode="numeric"
                            maxLength={6}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            {...register("confirm_pin", {
                              required: "Confirm PIN is required",
                              minLength: {
                                value: 4,
                                message:
                                  "Confirm PIN must be at least 4 digits",
                              },
                              pattern: {
                                value: /^[0-9]+$/,
                                message:
                                  "Confirm PIN must contain only numbers",
                              },
                              validate: (value) =>
                                value === getValues("pin") ||
                                "PINs do not match",
                            })}
                          />

                          <span
                            className="password_eye_icon"
                            onClick={() => setShowConfirmPin((prev) => !prev)}
                          >
                            {showConfirmPin ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </Form.Group>

                      {errors.confirm_pin && (
                        <sub className="text-danger">
                          {errors.confirm_pin.message}
                        </sub>
                      )}
                    </div>
                  </Form>

                  <div className="form_footer">
                    <div className="btn_holder">
                      <button
                        className="blue_btn"
                        type="button"
                        onClick={handleSubmit(onSubmit)}
                      >
                        Change
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-3 order-2 mb-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Change_Pin;
